const skipped_elements: string[] = ['IMG', 'BR', 'HR', 'INPUT', 'META', 'LINK'];

const cropHtmlElement: (element: Node, config: { count: number, limit: number }) => void = (element: Node, config: { count: number, limit: number }): void => {

    if (element.nodeType === Node.TEXT_NODE) {

        if (config.count >= config.limit) {

            element.textContent = "";
            return;
        }

        if (config.count + element.textContent.length > config.limit) {

            element.textContent = element.textContent.slice(0, config.limit - config.count) + "…";
            config.count = config.limit;

        } else {

            config.count += element.textContent.length;
        }

    } else if (element.nodeType === Node.ELEMENT_NODE) {

        Array.from(element.childNodes).forEach((child: Node): void => cropHtmlElement(child, config));
    }
};

const removeEmptyElements: (element: Element) => void = (element: Element): void => {

    Array.from(element.children).forEach((child: Element): void => {

        removeEmptyElements(child);

        if (!skipped_elements.includes(child.tagName) && child.textContent.trim() === "") {
            child.remove();
        }
    });
};

export const cropHtml: (html: string, limit: number) => string = (html: string, limit: number): string => {

    const croppedHtml: HTMLDivElement = document.createElement("div");

    croppedHtml.innerHTML = html;

    cropHtmlElement(croppedHtml, { count: 0, limit: limit });

    removeEmptyElements(croppedHtml);

    return croppedHtml.innerHTML;
};

